import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesResellers, VerificationDecision } from "../../constants";
import { UpdateResellerVerificationParams } from "./updateResellerVerification.types";

export const requestUpdateResellerVerification = async ({
  resellerId,
  decision,
  rejectionReason
}: UpdateResellerVerificationParams): Promise<void> => {
  const urlEnd =
    decision === VerificationDecision.Approve
      ? `approve/${resellerId}`
      : "decline";

  return await instance.put(
    buildUrl(ApiRoutesResellers.ResellerVerification, urlEnd),
    {
      resellerId,
      rejectionReason
    }
  );
};
